/* Carat & Kin — Backend Integration Helper v3 */

(function () {
  var PROXY_BASE = "/apps/cart-kin";

  async function checkDelivery(pincode, isCustomOrder, leadTimeDays) {
    var params = new URLSearchParams({
      pincode: pincode,
      is_custom_order: isCustomOrder ? "true" : "false",
      lead_time_days: String(leadTimeDays || 7),
    });
    var res = await fetch(PROXY_BASE + "/delivery?" + params);
    if (!res.ok) throw new Error("Delivery check failed");
    return res.json();
  }

  async function getProductWhatsAppLink(variantGid) {
    var res = await fetch(
      PROXY_BASE + "/whatsapp/product?variant_id=" + variantGid
    );
    if (!res.ok) throw new Error("WhatsApp link failed");
    return res.json();
  }

  async function getCartWhatsAppLink(items) {
    var res = await fetch(PROXY_BASE + "/whatsapp/cart", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    });
    if (!res.ok) throw new Error("WhatsApp cart link failed");
    return res.json();
  }

  async function getPriceBreakup(variantGid) {
    var res = await fetch(
      PROXY_BASE + "/price-breakup?variant_id=" + variantGid
    );
    if (!res.ok) throw new Error("Price breakup fetch failed");
    return res.json();
  }

  window.CartKin = {
    checkDelivery: checkDelivery,
    getProductWhatsAppLink: getProductWhatsAppLink,
    getCartWhatsAppLink: getCartWhatsAppLink,
    getPriceBreakup: getPriceBreakup,
  };
})();
